import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function isMobile() {
  if (typeof window === 'undefined') return false;
  // Use pointer capability instead of viewport width so the custom cursor
  // still renders on narrow desktop windows / resized browsers.
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches;
}

export function prefersReducedMotion() {
  if (typeof window === 'undefined') return false;
  return window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
}

/**
 * Run work when the main thread is idle, with a setTimeout fallback for
 * browsers without requestIdleCallback (Safari). The one shared copy of the
 * shim that used to be pasted into each idle-deferred section.
 */
export function runWhenIdle(cb: () => void, timeout = 2500, fallbackDelay = 1500) {
  if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
    (window as unknown as {
      requestIdleCallback: (cb: () => void, opts?: { timeout: number }) => number;
    }).requestIdleCallback(cb, { timeout });
  } else {
    setTimeout(cb, fallbackDelay);
  }
}
